import { SubPackageSlugEnum } from '@yaotai/common-utils';
import { EmailRegisterSubmitInfo } from '@yaotai/components';
import API from '../services';

import { encryptPassword } from './encryptPassword';

export const registerByEmail = async (info: EmailRegisterSubmitInfo, rsaKey: string, serverCode: string) => {
  const submitInfo = { ...info, server: serverCode, password: encryptPassword(info?.password!, rsaKey) };
  await API.current?.login!.postActivateRegister(submitInfo);
};

// 根据当前需要被重定向的页面是否有活动 aid，进一步判断需要去的登录页面
export const getExtractLoginPageUrl = ({ aid }: { aid?: string }) => {
  return aid ? `/${SubPackageSlugEnum.Center}/activity/${aid}/login` : `/${SubPackageSlugEnum.Center}/login`;
};

export const getSpecificActivityLoginPath = (aid: string) => {
  return `/${SubPackageSlugEnum.Center}/activity/${aid}/login`;
};
